<template>
  <div class="container">
    <div class="title animate-target" v-animate-in>
      Part 2
      <hr/>
    </div>
    <h1 class="animate-target" v-animate-in>{{$route.meta.sub_header}}</h1>

    <router-link to="/section2/2-1" class="btn btn_kerendia animate-target" v-animate-in>Continue</router-link>
  </div>
</template>

<script>
export default {
  name: "s2_index"
}
</script>

<style scoped>
@import "../../assets/css/section2/s2.css";
</style>
